import { combineReducers } from "redux";
import StatusReducer from "./batch_status/Reducer.Claim_Status";
import UploadedClaimsReducer from "./submit_claims/Reducer.Submit_Claims";
import RecentBatchReducer from './submit_claims/recent_batch/Reducer.Recent_Batches';
import EraReducer from "./era/Reducer.Era";
import { billingInformations, companyProfile} from './reducers/allReducers';
import UserReducer from './login_page/user.reducer';

const rootReducer = combineReducers({
  statusUpdates: StatusReducer,
  submitClaims: UploadedClaimsReducer,
  recentBatches: RecentBatchReducer,
  era: EraReducer,
  settingsData: companyProfile,
  billingData: billingInformations,
  userData: UserReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/root_reducer.js